import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { LoteProduto } from 'src/app/models/lote-produto';
import { VendaItemLote } from 'src/app/models/venda-item-lote';
import { CarregandoService } from 'src/app/services/carregando.service';
import { GlobalService } from 'src/app/services/global.service';
import { LoteProdutoService } from 'src/app/services/lote-produto.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { PremissasService } from 'src/app/services/premissas.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';

// jquery
declare const $: any;

@Component({
  selector: 'app-trocar-de-lote-modal',
  templateUrl: './trocar-de-lote-modal.component.html',
  styleUrls: ['./trocar-de-lote-modal.component.scss']
})
export class TrocarDeLoteModalComponent implements OnInit, OnDestroy {

  // variáveis
  // produtos: Produto[] = [];
  lotes: LoteProduto[] = [];
  pLotes: VendaItemLote[] = [];

  public config: PerfectScrollbarConfigInterface = {};

  idFornecedor;
  idProduto;
  idCupom;

  loteSelecionado: LoteProduto;
  vendaItemLoteSelecionado: VendaItemLote;

  constructor(private loteProdutoService: LoteProdutoService, public utilitarioService: UtilitarioService, private premissasService: PremissasService,
    private router: Router, private carregandoService: CarregandoService, private notificacaoService: NotificacaoService, private globalService: GlobalService,
    public dialogRef: MatDialogRef<TrocarDeLoteModalComponent>, @Inject(MAT_DIALOG_DATA) public data: any, public dialog: MatDialog) { }

  async ngOnInit() {
    this.idFornecedor = this.data.idFornecedor;
    this.idProduto = this.data.idProduto;
    this.idCupom = this.data.idCupom;
    this.buscarLotes();
    this.buscarVendaItemLotes();
  }

  buscarLotes() {
    this.carregandoService.mostra('buscarLotes');

    this.loteProdutoService.consultarPorIdProduto(this.idProduto, this.idFornecedor).subscribe(dados => {
      this.lotes = dados;
      this.carregandoService.esconde('buscarLotes');
    }, (erro) => {
      this.carregandoService.esconde('buscarLotes');
      this.notificacaoService.erro(erro);
    });
  }

  buscarVendaItemLotes() {
    this.carregandoService.mostra('buscarVendaItemLotes');

    this.loteProdutoService.consultarLotesPorIdCupom(this.idCupom, this.idProduto, this.idFornecedor).subscribe(dados => {
      this.pLotes = dados;
      this.carregandoService.esconde('buscarVendaItemLotes');
    }, (erro) => {
      this.carregandoService.esconde('buscarVendaItemLotes');
      this.notificacaoService.erro(erro);
    });
  }

  trocarDeLote() {

    if (this.vendaItemLoteSelecionado === null || this.vendaItemLoteSelecionado === undefined
      || this.loteSelecionado === null || this.loteSelecionado === undefined)
      return;

    this.carregandoService.mostra('buscarVendaItemLotes');

    this.loteProdutoService.trocarDeLote(this.vendaItemLoteSelecionado.lote, this.loteSelecionado.lote, this.vendaItemLoteSelecionado.qtd, this.idCupom, this.idProduto, this.idFornecedor).subscribe(dados => {
      this.carregandoService.esconde('buscarVendaItemLotes');
      this.notificacaoService.sucesso('Lote alterado com sucesso!!!');
      this.dialogRef.close(dados);
    }, (erro) => {
      this.carregandoService.esconde('buscarVendaItemLotes');
      this.notificacaoService.erro(erro);
    });
  }

  fechar() {
    this.dialogRef.close();
  }

  ngOnDestroy(): void {

  }


}
